import { useTranslation } from "react-i18next";
import LanguageSwitcher from "../LanguageSwitcher/LanguageSwitcher";
import "./Header.css";

const NAV = [
  { href: "#servicos", key: "services" },
  { href: "#produtos", key: "products" },
  { href: "#seguranca", key: "security" },
  { href: "#processo", key: "process" },
  { href: "#contato", key: "contact" },
];

export default function Header() {
  const { t } = useTranslation();
  return (
    <header className="header">
      <div className="container header__inner">
        <a className="header__brand" href="#top" aria-label={t("header.brand_aria")}>
          <img src="/niertech-logo.svg" alt="" className="header__logo" />
          <span className="header__wordmark">niertech</span>
        </a>

        <nav className="header__nav" aria-label={t("header.nav_aria")}>
          {NAV.map((link) => (
            <a key={link.href} href={link.href} className="header__link">
              {t(`header.nav.${link.key}`)}
            </a>
          ))}
        </nav>

        <div className="header__right">
          <LanguageSwitcher />
          <a href="#contato" className="header__cta">
            {t("header.cta")}
          </a>
        </div>
      </div>
    </header>
  );
}
